import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const isLoadingSelector = (statusKey) => (state) => state.import[statusKey] === REDUX_ASYNC_STATUSES.LOADING;
const isFailedSelector = (statusKey) => (state) => state.import[statusKey] === REDUX_ASYNC_STATUSES.FAILED;
const isSucceededSelector = (statusKey) => (state) => state.import[statusKey] === REDUX_ASYNC_STATUSES.SUCCEEDED;

export const selectImportFile = (state) => state.import?.importFile;
export const selectImportJsonData = (state) => state.import?.importJsonData;

export const selectDownloadImportTemplateLoading = isLoadingSelector('downloadImportTemplateStatus');
export const selectExportRisksAndPoliciesFileLoading = isLoadingSelector('exportRisksAndPoliciesFileStatus');

export const selectCheckImportFileLoading = isLoadingSelector('checkImportFileStatus');
export const selectCheckImportFileFailed = isFailedSelector('checkImportFileStatus');

export const selectExecuteImportLoading = isLoadingSelector('executeImportStatus');
export const selectExecuteImportFailed = isFailedSelector('executeImportStatus');
export const selectExecuteImportSucceeded = isSucceededSelector('executeImportStatus');
